import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { Badge, Card, Modal, Button, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Block from "../../components/Block/Block";
import { Icon } from "../../components";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import { Spinner } from "react-bootstrap";
import {
  createShiftApi,
  getShiftListApi,
} from "../../services/TransportService";
import { toast } from "react-toastify";
import { add } from "lodash";
import format from "date-fns/format";
import parse from "date-fns/parse";
const formatTime = (timeStr) => {
  if (!timeStr) return 'N/A';
  const parsedTime = parse(timeStr, 'HH:mm:ss', new Date());
  return format(parsedTime, 'hh:mm a');
};
function ShiftListPage({ userRole }) {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isAddSubmiting, setIsAddSubmiting] = useState(false);
  const [errormessage, setErrormessage] = useState("");
  const [addFormFields, setAddFormFields] = useState({
    name: "",
    start_time: "",
    end_time: "",
    drop_start_time: "",
    drop_end_time: "",
  });
  const [errorform, setErrorform] = useState({
    name: "",
    start_time: "",
    end_time: "",
    drop_start_time: "",
    drop_end_time: "",
  });
  const [filter, setFilter] = useState({
    page: "",
    page_size: "",
    query: "",
    status: "",
  });
  const [modalVisible, setModalVisible] = useState(false);

  const fetchData = useCallback(() => {
    setIsLoading(true);
    getShiftListApi(filter)
      .then((resp) => {
        setData(resp.data);
        setTotal(resp.data?.total || 0);
      })
      .catch((error) => {
        console.error(error?.response?.data?.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [filter.currentPage, filter.query, filter.status]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handlePageChange = (page) => {
    setFilter((prev) => ({
      ...prev,
      page: page,
    }));
  };

  const handleSearchChange = (value) => {
    setFilter((prev) => ({
      ...prev,
      // page: 1,
      query: value,
    }));
  };

  const handleToggleModal = () => {
    if (modalVisible) {
      setErrormessage('')
      setAddFormFields({
        name: "",
        start_time: "",
        end_time: "",
        drop_start_time: "",
        drop_end_time: "",
      });
      setErrorform({
        name: "",
        start_time: "",
        end_time: "",
        drop_start_time: "",
        drop_end_time: "",
      });
    }
    setModalVisible((prev) => !prev);
  };

  const handleSubmit = () => {
    let valid = true;
    const error = {
      name: "",
      start_time: "",
      end_time: "",
      drop_start_time: "",
      drop_end_time: "",
    };
    if (!addFormFields.name) {
      error.name = "Shift name is required";
      valid = false;
    }
    if (!addFormFields.start_time) {
      error.start_time = "Pickup start time is required";
      valid = false;
    }
    if (!addFormFields.end_time) {
      error.end_time = "Pickup end time is required";
      valid = false;
    }
    if (!addFormFields.drop_start_time) {
      error.drop_start_time = "Drop start time is required";
      valid = false;
    }
    if (!addFormFields.drop_end_time) {
      error.drop_end_time = "Drop end time is required";
      valid = false;
    }
    setErrorform(error);
    if (valid) {
      setIsAddSubmiting(true);
      createShiftApi(addFormFields)
        .then((resp) => {
          setData((prev) => [resp.data, ...prev]);
          setTotal((prev) => prev + 1);
          handleToggleModal();
          toast.success("Shift Created Successfully");
        })
        .catch((error) => {
          setErrormessage(
            error?.response?.data?.message ||
              error?.response?.data?.error ||
              "Please try again later"
          );
        })
        .finally(() => {
          setIsAddSubmiting(false);
        });
    }
  };

  return (
    <div>
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">Shifts</Block.Title>
            <nav>
              <ol className="breadcrumb breadcrumb-arrow mb-0">
                <li className="breadcrumb-item">
                  <Link to="/">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Shifts
                </li>
              </ol>
            </nav>
          </Block.HeadContent>

          <Block.HeadContent>
            <ul className="d-flex">
              <li className="me-2">
                <DebounceSearchInput
                  handleSearchChange={handleSearchChange}
                  placeholder="Search Shift.."
                />
              </li>
              <li>
                {userRole === "Admin" && (
                  <Button
                    className="d-md-inline-flex"
                    variant="primary"
                    onClick={handleToggleModal}
                  >
                    <Icon name="plus" />
                    <span>Add Shift</span>
                  </Button>
                )}
              </li>
            </ul>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>
      <Block>
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center p-3">
            <Spinner animation="border" size="sm" />
            <span className="ms-1">Loading...</span>
          </div>
        ) : (
          <Row>
            {data.map((item, index) => (
              <Col xs={12} sm={6} md={4} lg={3} key={index} className="mb-3">
                <Card className="card-hover-shadow">
                  <Card.Body className="p-0">
                    <div className="d-flex justify-content-between align-items-center p-3">
                      <div>
                        <h5>{item.name}</h5>
                        <span>
                          <span className="me-1" style={{ fontWeight: "510" }}>
                            Pickup:
                          </span>
                          {item.start_time?formatTime(item.start_time):'N/A'} - {item.end_time?formatTime(item.end_time):'N/A'}
                        </span>
                        <br></br>
                        <span>
                          <span className="me-1" style={{ fontWeight: "510" }}>
                            Drop:
                          </span>
                          {item.drop_start_time?formatTime(item.drop_start_time):'N/A'} - {item.drop_end_time?formatTime(item.drop_end_time):'N/A'}
                        </span>
                      </div>
                      {/* {userRole === "Admin" && (
                        <Link to={`/Shift/${item.id}`} className="btn btn-primary btn-sm">
                          Edit
                        </Link>
                      )} */}
                    </div>
                    <div className="d-flex justify-content-start align-items-center pb-3 ps-3">
                      <Link
                        to={`/shift/${item.id}`}
                        className="btn btn-outline-primary btn-sm"
                      >
                        View Details{" "}
                        <Icon className={"ms-2"} name="arrow-right" />
                      </Link>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}

        <Modal
          show={modalVisible}
          onHide={handleToggleModal}
          centered
          className="custom-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Create Shift</Modal.Title>
          </Modal.Header>

          <Modal.Body className="py-4">
            <div className="filter-sections">
              {errormessage && (
                <div className="alert alert-danger">{errormessage}</div>
              )}
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Shift Name
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errorform.name ? "is-invalid" : ""
                  }`}
                  id="name"
                  placeholder="Enter Shift Name"
                  value={addFormFields.number_plate}
                  onChange={(e) =>
                    setAddFormFields({ ...addFormFields, name: e.target.value })
                  }
                />
              </div>
              <div className="d-flex justify-content-between gap-3 align-items-center">
                <div className="mb-3 w-100">
                  <label htmlFor="start_time" className="form-label">
                    Pickup Start Time
                  </label>
                  <input
                    type="time"
                    className={`form-control ${
                      errorform.start_time ? "is-invalid" : ""
                    }`}
                    id="start_time"
                    value={addFormFields.start_time}
                    onChange={(e) =>
                      setAddFormFields({
                        ...addFormFields,
                        start_time: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="mb-3 w-100">
                  <label htmlFor="end_time" className="form-label">
                    Pickup End Time
                  </label>
                  <input
                    type="time"
                    className={`form-control ${
                      errorform.end_time ? "is-invalid" : ""
                    }`}
                    id="end_time"
                    value={addFormFields.end_time}
                    onChange={(e) =>
                      setAddFormFields({
                        ...addFormFields,
                        end_time: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="d-flex justify-content-between gap-3 align-items-center">
                <div className="mb-3 w-100">
                  <label htmlFor="start_time" className="form-label">
                    Drop Start Time
                  </label>
                  <input
                    type="time"
                    className={`form-control ${
                      errorform.drop_start_time ? "is-invalid" : ""
                    }`}
                    id="start_time"
                    value={addFormFields.drop_start_time}
                    onChange={(e) =>
                      setAddFormFields({
                        ...addFormFields,
                        drop_start_time: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="mb-3 w-100">
                  <label htmlFor="end_time" className="form-label">
                    Drop End Time
                  </label>
                  <input
                    type="time"
                    className={`form-control ${
                      errorform.drop_end_time ? "is-invalid" : ""
                    }`}
                    id="end_time"
                    value={addFormFields.drop_end_time}
                    onChange={(e) =>
                      setAddFormFields({
                        ...addFormFields,
                        drop_end_time: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="outline-secondary"
              disabled={isAddSubmiting}
              onClick={handleToggleModal}
            >
              Cancel
            </Button>

            <Button
              variant="primary"
              disabled={isAddSubmiting}
              onClick={handleSubmit}
            >
              Create
              {isAddSubmiting && (
                <span
                  className="spinner-border spinner-border-sm ms-2"
                  role="status"
                  aria-hidden="true"
                ></span>
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </Block>
    </div>
  );
}

const mapStateToProps = (state) => ({
  userRole: state.auth.user?.role || "Employee",
});

export default connect(mapStateToProps)(ShiftListPage);
